"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trustedVerificationStatusRepository = void 0;
const resolver_1 = require("./resolver");
const mapper_1 = require("./mapper");
exports.trustedVerificationStatusRepository = {
    isVerified: (api, progressId, data, url) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield (0, resolver_1.fetchCheckTrustedVerificationStatus)(api, progressId, data, url);
        return (0, mapper_1.mapIsVerified)(response.data);
    }),
};
//# sourceMappingURL=repository.js.map